export const user = {
  name: "Hiranmaya",
  username: "hmgundu",
  avatar:
    "https://pbs.twimg.com/profile_images/1257658164163391489/Czzo5pxa_400x400.jpg",
};